import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { ElementName } from '../../../../../constants';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { BaseLinkElement, toLinkProps } from '../common';
var TitleElement = function TitleElement(props) {
  var context = useFlexibleUiContext();
  var data = context ? fg('platform-linking-flexible-card-context') ? context === null || context === void 0 ? void 0 : context.linkTitle : toLinkProps(context.title, context.url) : null;
  return data ? /*#__PURE__*/React.createElement(BaseLinkElement, _extends({}, data, props, {
    name: ElementName.Title
  })) : null;
};
export default TitleElement;